import { Card, CardBody, CardHeader, CardHeading, useIsAddonEnabled } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { DetailsPageInfoField } from "../../../../shared/ui/DetailsPageInfoField";
import { EventDetailResource } from "../../shared/types";

interface Props {
	event: EventDetailResource;
}

const GridCardBody = styled(CardBody)`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-gap: ${({ theme }) => theme.spacing(2)};
`;

export const EventParticipantsCard: FC<Props> = ({ event }) => {
	const { t } = useTranslation();
	const isContactDatabaseEnabled = useIsAddonEnabled("contactDatabase");

	return (
		<Card>
			<CardHeader>
				<CardHeading>{t("Participants")}</CardHeading>
			</CardHeader>
			<GridCardBody>
				{event.eventType.plannedPersonCountRequirement !== "prohibited" && (
					<DetailsPageInfoField title={t("Planned person count")} value={event.plannedPersonCount || 0} />
				)}
				{isContactDatabaseEnabled && (
					<DetailsPageInfoField title={t("People on invitation list")} value={event.invitationListStats.total} />
				)}
				{isContactDatabaseEnabled && (
					<DetailsPageInfoField title={t("Will attend")} value={event.invitationListStats.willAttend} />
				)}
				{isContactDatabaseEnabled && (
					<DetailsPageInfoField title={t("Will not attend")} value={event.invitationListStats.willNotAttend} />
				)}
				{isContactDatabaseEnabled && (
					<DetailsPageInfoField
						title={t("Participation status")}
						value={
							event.participationStatus === "none" ? "-" : t(`eventParticipationStatus.${event.participationStatus}`)
						}
					/>
				)}
			</GridCardBody>
		</Card>
	);
};
